<template>
    <div class="CFormGroup" :class="{ 'CFormGroup--invalid': error }">
        <div v-if="!!$slots['label'] || label" class="mb-1.5 flex items-center gap-2">
            <div class="flex items-baseline">
                <CLabel class="mb-0 w-fit">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </CLabel>
                <span v-if="required" class="ml-1 font-normal text-red-500">*</span>
            </div>

            <CTooltip v-if="tooltip">{{ tooltip }}</CTooltip>

            <span v-if="labelNote" class="self-end text-sm font-normal leading-none text-gray-500 dark:text-txt-body">
                {{ labelNote }}
            </span>

            <div v-if="$slots['side']" class="ml-auto! mr-0!">
                <slot name="side" />
            </div>
        </div>

        <div
            v-if="!!$slots['description'] || description"
            class="-mt-1.5 mb-2 max-w-3xl text-sm text-gray-800 dark:text-txt-body"
        >
            <slot name="description">
                {{ description }}
            </slot>
        </div>

        <div class="relative flex flex-col overflow-visible">
            <slot />

            <span v-if="labelInfo" class="mt-2 text-sm font-normal leading-none text-gray-500 dark:text-txt-body">
                {{ labelInfo }}
            </span>
        </div>

        <div v-if="$slots.hint" class="mb-2 mt-1.5 text-sm text-gray-800 dark:text-txt-body">
            <slot name="hint" />
        </div>

        <div v-if="$slots.footer" class="text-sm text-gray-800 dark:text-txt-body">
            <slot name="footer" />
        </div>

        <div v-if="error && !hideErrorMessage" class="mt-1 text-sm text-red-500">
            {{ error }}
        </div>
    </div>
</template>

<script setup lang="ts">
import CLabel from '@/components/ui/CLabel.vue'
import CTooltip from '@/components/ui/CTooltip.vue'

defineProps({
    label: {
        type: String,
        default: ''
    },
    labelSpacer: {
        type: [Number, String],
        default: 0
    },
    required: {
        type: Boolean
    },
    tooltip: {
        type: String,
        default: ''
    },
    error: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: ''
    },
    labelInfo: {
        type: [Number, String],
        default: ''
    },
    hideErrorMessage: {
        type: Boolean
    },
    labelNote: {
        type: String,
        default: ''
    }
})
</script>
